var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.35156C17.0503 5.35156 18.7109 7.01221 18.7109 9.0625V12.0312H11.2891V9.0625C11.2891 7.01221 12.9497 5.35156 15 5.35156ZM9.0625 9.0625V12.0312H7.57812C5.94067 12.0312 4.60938 13.3625 4.60938 15V23.9062C4.60938 25.5437 5.94067 26.875 7.57812 26.875H22.4219C24.0593 26.875 25.3906 25.5437 25.3906 23.9062V15C25.3906 13.3625 24.0593 12.0312 22.4219 12.0312H20.9375V9.0625C20.9375 5.78296 18.2795 3.125 15 3.125C11.7205 3.125 9.0625 5.78296 9.0625 9.0625ZM7.57812 14.2578H22.4219C22.8301 14.2578 23.1641 14.5918 23.1641 15V23.9062C23.1641 24.3145 22.8301 24.6484 22.4219 24.6484H7.57812C7.16992 24.6484 6.83594 24.3145 6.83594 23.9062V15C6.83594 14.5918 7.16992 14.2578 7.57812 14.2578ZM16.1133 17.9688C16.1133 17.3518 15.6169 16.8555 15 16.8555C14.3831 16.8555 13.8867 17.3518 13.8867 17.9688V20.9375C13.8867 21.5544 14.3831 22.0508 15 22.0508C15.6169 22.0508 16.1133 21.5544 16.1133 20.9375V17.9688Z",
    fill: "#334155"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.24ea71a4c9662ec6673914df52d6e928.svg";
export { ForwardRef as ReactComponent };